export default "__VITE_ASSET__9cfa4aeb__"